import React, { useEffect, useRef, useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "./Index.css";

import Header from "../header/Index.js";
import hamburger from "../../assets/img/hamburgergroup.svg";
import backArraow from "../../assets/img/back_arrow.svg";
import alertIcon from "../../assets/img/alert_icon.svg";
import crossIcon from "../../assets/img/cross.svg";

import LightPlacementComponent from "../lightPlacementView/Index.jsx";
import FourCircles, {
  OneCircles,
  SixCircles,
  EightCircles,
  TwoCircles,
} from "../groupOfCircle/Index.js";
import { OldSpinnerLoader } from "../../loader/Index.js";
import grids from "../../assets/img/gridlines.svg";
import greeHseSVG from "../../assets/img/greenhseicon.svg";

//Third Party Imports
import DeleteIcon from "@mui/icons-material/Delete";
import CropIcon from "@mui/icons-material/Crop";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { useNavigate, useLocation } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "react-tiny-fab/dist/styles.css";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import CloseIcon from "@mui/icons-material/Close";
import html2canvas from "html2canvas";
import Sidebar from "react-sidebar";
import ZoomOutRoundedIcon from "@mui/icons-material/ZoomOutRounded";
import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import Joyride, { STATUS } from "react-joyride";
import Icon from "@mdi/react";
import { mdiDownload } from "@mdi/js";
import { mdiPrinter } from "@mdi/js";
import { mdiFileDownloadOutline } from "@mdi/js";
import { jsPDF } from "jspdf";
import printJS from "print-js";
import greenHseSmallLogo from "../../assets/img/greenhse-logo-small.png";
import {
  loadLogo,
  convertSVGToPNG,
} from "../../utilities/helpers/commonHelper.js";
import { emailAndAddress } from "../config/config.js";

import {
  getFile,
  // updateCroppedFile,
  updateEstimateName,
  // deleteCroppedFile,
  // deleteMainFile,
  // getPDFFile,
  // updateCroppedCopyOfPDF,
  // getCroppedFile,
  // getMainFile,
  // deletePages,
  // saveLightPlacementPositions,
  // storeDocumentsForDownload,
  // GetAllLightPlacement,
  // removeInvalidLightPlacements,
  // GetScreenShot,
  // saveScreenshotFile,
} from "../../IndexedDB.js";

const predefinedCombos = {
  "1": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },    
  ],
  "2": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false, row:1,col:0 },    
  ],
  "4": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false, row:1,col:0 },
    { id: "C", fixed: false, fixedX: false, fixedY: true, row:0,col:1},
    { id: "D", fixed: false, fixedX: false, fixedY: false, row:1,col:1},
  ],
  "6": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false ,row:1,col:0},
    { id: "C", fixed: false, fixedX: true, fixedY: false ,row:2,col:0},
    { id: "D", fixed: false, fixedX: false, fixedY: true ,row:0,col:1},
    { id: "E", fixed: false, fixedX: false, fixedY: false ,row:1,col:1},
    { id: "F", fixed: false, fixedX: false, fixedY: false ,row:2,col:1},    
  ],
  "6-1": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false ,row:1,col:0},
    { id: "C", fixed: false, fixedX: false, fixedY: true ,row:0,col:1},
    { id: "D", fixed: false, fixedX: false, fixedY: false ,row:1,col:1},
    { id: "E", fixed: false, fixedX: false, fixedY: true ,row:0,col:2},
    { id: "F", fixed: false, fixedX: false, fixedY: false ,row:1,col:2},    
  ],

  "8": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false ,row:1,col:0},
    { id: "C", fixed: false, fixedX: true, fixedY: false ,row:2,col:0},
    { id: "D", fixed: false, fixedX: true, fixedY: false ,row:3,col:0},
    { id: "E", fixed: false, fixedX: false, fixedY: true ,row:0,col:1},
    { id: "F", fixed: false, fixedX: false, fixedY: false ,row:1,col:1},
    { id: "G", fixed: false, fixedX: false, fixedY: false ,row:2,col:1},    
    { id: "H", fixed: false, fixedX: false, fixedY: false ,row:3,col:1},    
  ],
  "8-1": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false ,row:1,col:0},
    { id: "C", fixed: false, fixedX: false, fixedY: true ,row:0,col:1},
    { id: "D", fixed: false, fixedX: false, fixedY: false ,row:1,col:1},
    { id: "E", fixed: false, fixedX: false, fixedY: true ,row:0,col:2},
    { id: "F", fixed: false, fixedX: false, fixedY: false ,row:1,col:2}, 
    { id: "G", fixed: false, fixedX: false, fixedY: true ,row:0,col:3},
    { id: "H", fixed: false, fixedX: false, fixedY: false ,row:1,col:3},    
  ],

  "9": [
    { id: "A", fixed: true,fixedX: true, fixedY: true, row:0,col:0 },
    { id: "B", fixed: false, fixedX: true, fixedY: false ,row:1,col:0},
    { id: "C", fixed: false, fixedX: true, fixedY: false ,row:2,col:0},
    { id: "D", fixed: false, fixedX: false, fixedY: true ,row:0,col:1},
    { id: "E", fixed: false, fixedX: false, fixedY: false ,row:1,col:1},
    { id: "F", fixed: false, fixedX: false, fixedY: false ,row:2,col:1},
    { id: "G", fixed: false, fixedX: false, fixedY: true ,row:0,col:2},
    { id: "H", fixed: false, fixedX: false, fixedY: false ,row:1,col:2},
    { id: "I", fixed: false, fixedX: false, fixedY: false ,row:2,col:2},    
  ],  
};

export default function App() {
  const [image, setImage] = useState(null);
  const [isDraggingGroup, setIsDraggingGroup] = useState(true);
  const [savedCombos, setSavedCombos] = useState([]);
  const [activeKey, setActiveKey] = useState("");
  const zoomRef = useRef(null);
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const [selectedPdfImageForCrop, setSelectedPdfImageForCrop] = React.useState(
    []
  );
  const [actualFileName, setActualFileName] = useState("");
  const [fileObj, setFileObj] = useState();
  const [error, setError] = useState("");
  const [headerText, setHeaderText] = useState("Edit Images");
  const [showHamburgerBlock, setShowHamburgerBlock] = useState(false);

  const [headerSaveText, setHeaderSaveText] = useState("Estimate");


  const navigate = useNavigate();
    const cropperRef = useRef(null);
   
    const [showDeletePopup, setShowDeletePopup] = useState(false);
   
    //Original File name
    const [mainFileName, setMainFileName] = useState("");
    const [pdfFile, setPdfFile] = useState();
    const [mainImageUrl, setMainImageUrl] = useState("");
    //Use state to manage croping is start or not on edit icon clicked
    const [startCropping, setStartCropping] = useState(false);
    //Get PDF document from uri.
    const [pdf, setPdf] = React.useState("");
    //Array of images extracted from PDF.
    const [pdfImages, setPdfImages] = React.useState([]);
    const [pdfActualImages, setPDFActualImages] = React.useState([]);
    //Array of images extracted from PDF.
    
    const [pdfCropImagePageNumber, setPdfCropImagePageNumber] = useState(() => {
      const savedIndex = parseInt(localStorage.getItem("activePageIndex"), 10);
      return isNaN(savedIndex) ? 0 : savedIndex - 1;
    });
    const [pdfRendering, setPdfRendering] = React.useState("");
    const [croppedFileName, setCroppedFileName] = useState("");
    const [fetchCount, setFetchCount] = useState(0);
    const [fileData, setFileData] = useState();
    const [activePage, setActivePage] = useState(() => {
      const savedPage = parseInt(localStorage.getItem("activePage"), 10);
      return isNaN(savedPage) ? 0 : savedPage;
    });
    const [totalPages, setTotalPages] = useState([]);
    const [isLightPlacement, setIsLightPlacement] = useState(false);
    const [lightColorsArray, setLightColorArray] = useState([]);
    const [circleUrl, setCircleUrl] = useState("");
    

    // Get positions hook
    const [isLoading, setIsLoading] = useState(false);
    const [isGridBlockClicked, setIsGridBlockClicked] = useState(false);
    const [isSavePopupOpen, setIsSavePopupOpen] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [hideSideView, setHideSideView] = useState(false);
    const [hideHamburgerIcon, setHideHamburgerIcon] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [changePopupText, setChangePopupText] = useState(false);
    const [count, setCount] = useState(0);
  
    const [localStorageArr, setLocalStorageArr] = useState(
      JSON.parse(localStorage.getItem("currentNodePositions"))
    );
    const [localActiveIndex, setLocalActiveIndex] = useState(() => {
      const savedIndex = parseInt(localStorage.getItem("activePageIndex"), 10);
      return isNaN(savedIndex) ? 0 : savedIndex;
    });
    const [activePageIndex, setActivePageIndex] = useState(() => {
      const savedIndex = parseInt(localStorage.getItem("activePageIndex"), 10);
      return isNaN(savedIndex) ? 0 : savedIndex;
    });
  
    // Get positions hook
    const [lightPlacementPositions, setLightPlacementPositions] = useState([]);
    const [pdfSideView, setPdfSideView] = useState([]);
    const [resolvedImages, setResolvedImages] = useState([]);
    const [showLightPlacementComp, setShowLightPlacementComp] = useState(false);
    const [selectedProductcomp, setselectedProductComp] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showHomepage, setShowHomepage] = useState(
      () => JSON.parse(localStorage.getItem("showHomepage")) !== false
    );
    // Check save button click
    const [isSaveHandleClick, setIsSaveHandleClick] = useState(false);
    const [showJoyride, setShowJoyride] = useState(false);
    const theRef = React.useRef(null);
    const ref = useRef();
    var croppedFile;
    const location = useLocation();
    const selectedProduct = selectedProductcomp;
    var selectedProductList = [];
    selectedProductList.push(selectedProduct);
  
    //States used for zoom
    const [zoomCount, setZoomCount] = useState(0);
    const [isZoomIn, setIsZoomIn] = useState(false);
    const [isSingleClick, setIsSingleClick] = useState(false);
    const [run1, setRun1] = useState(true);
    const [run2, setRun2] = useState(true);
    var difference;
    const [startingPositions, setStartingPositions] = useState({
      normalStart: 0,
      zoomedStart: 0,
      normalEnd: 0,
      zoomedEnd: 0,
      normalWidth: 0,
      zoomedWidth: 0,
      normalAttempt: 0,
      zoomedAttempt: 0,
    });
    const [dimensions, setDimensions] = useState({});
    const [getFileName, setGetFileName] = useState(
      window.location.href.replaceAll("%20", "").split("=")[1]
    );

  useEffect(() => {
    fetchFile();

    // const storedImage = localStorage.getItem("uploadedImage");
    // if (storedImage) setImage(storedImage);

    // const storedCombos = localStorage.getItem("savedCombos");
    // if (storedCombos) setSavedCombos(JSON.parse(storedCombos));
  }, []);
 const toggleHamburgerBlock = () => {
    setShowHamburgerBlock(!showHamburgerBlock);
  };
  const handleLightbulbClick = () => {
    setIsGridBlockClicked(true);
    setShowLightPlacementComp(true);

    // setShowGrid(true);
    // setHideSideView(true);
    // setHideHamburgerIcon(true);
    // setIsLightPlacement(true);
    setHeaderText("Light Placement");
    setHeaderSaveText("Save");
    // localStorage.setItem("isGridEnable", "true");
    // const imagesWithIndex = pdfImages.map((image, index) => ({ index, image }));
    // localStorage.setItem("pdfImages", JSON.stringify(imagesWithIndex));
    // console.log("pdfImages saved to localStorage:", imagesWithIndex);
  };
  const closeSidebar = () => {
    setShowLightPlacementComp(false); // Close sidebar when close icon clicked
   
  };
   const handleLightPlacementToggle = () => {
    if (showLightPlacementComp == true) {
      setShowLightPlacementComp(false);      
    } else {
      setShowLightPlacementComp(true);
    }
  };
  const handleMessage = (data) => {
    console.log("data", data);
    setselectedProductComp(data);
    addCombo(data.quantity);
    // setLocalStorageArr(
    //   JSON.parse(localStorage.getItem("currentNodePositions"))
    // );
    // setselectedProductComp(data);
  };
  const fetchFile = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      console.log('params', params);
      const fileName = params.get("file");
      const croppedFileName = params.get("croppedFile");
      const fileNameAfterURLDecode = decodeURIComponent(fileName);
      const croppedFileNameAfterURLDecode = decodeURIComponent(croppedFileName);

      // var isPlaceLight = new URLSearchParams(window.location.href);
      // isPlaceLight = isPlaceLight.get("placeLight");
      // setCircleUrl(isPlaceLight);
      // // console.log('isPlaceLight', isPlaceLight);
      // if (isPlaceLight) {
      //   const colors = isPlaceLight.split(",");
      //   setLightColorArray(colors);
      // }

      // if (startCropping) {
      //   if (fileNameAfterURLDecode.includes(".pdf")) {
      //     renderPage();
      //   }
      //   setStartCropping(false);

      //   return;
      // }

      setActualFileName(fileNameAfterURLDecode);

      // if (
      //   mainFileName == "croppedFileSet" ||
      //   mainFileName == fileNameAfterURLDecode
      // ) {
      //   if (mainFileName == fileNameAfterURLDecode) {
      //     navigate(-1);
      //   }
      // }

      // setMainFileName(fileNameAfterURLDecode);
      // setCroppedFileName(croppedFileNameAfterURLDecode);
      // // Ensure the fileUrlObj fetched from getFile is correct
      const storedFile = await getFile(
        fileNameAfterURLDecode,
        croppedFileNameAfterURLDecode != "null" ||
          croppedFileNameAfterURLDecode != null
          ? croppedFileNameAfterURLDecode
          : undefined
      );
      console.log('storedFile', storedFile);
      // if (fileNameAfterURLDecode.includes("pdf")) {
      //   var pdfFile = await getPDFFile(fileNameAfterURLDecode);
      //   setPdfFile(pdfFile);
      //   const uri = URL.createObjectURL(pdfFile.file);
      //   PDFJS.getDocument(uri).promise.then(function (pdf) {
      //     setPdf(pdf);
      //   });
      // }

      const fileData = {
        ...storedFile,
      };

      var uri = URL.createObjectURL(storedFile);
      setImage(uri);

      // if (!fileNameAfterURLDecode.includes("pdf")) {
      //   if (
      //     mainFileName == "croppedFileSet" &&
      //     !fileNameAfterURLDecode.includes("pdf")
      //   ) {
      //     var mainFile = await getMainFile(fileNameAfterURLDecode);
      //     uri = URL.createObjectURL(mainFile);
      //   } else {
      //     var croppedImages = await getCroppedFile(fileNameAfterURLDecode);
      //     var croppedFileSRC = croppedImages[0];
      //     if (croppedImages.length > 0) {
      //       uri = URL.createObjectURL(new Blob([croppedFileSRC.croppedFile]));
      //     }
      //   }
      // }

      // //When file type is pdf
      // if (storedFile && storedFile.type == "application/pdf") {
      //   setPdfRendering(true);
      //   setFileData(storedFile);
      //   //Get the pdf file to convert it into images.
      //   PDFJS.getDocument(uri).promise.then(function (pdf) {
      //     setPdf(pdf);
      //   });
      //   setPdfRendering(false);
      // } else {
        setSelectedPdfImageForCrop(uri);
        console.log("Selected PDF image for crop:", uri);
        // setMainImageUrl(uri);
      // }

      // if (storedFile) {
      //   setFileObj(storedFile);

      //   setError(""); // Clear error state if file is successfully loaded
      // } else {
      //   setError("File not found in Database");
      // }

      // setFileObj(storedFile);

      // setFetchCount(fetchCount++);

      // for (let i = 0; i < croppedImages.length; i++) {
      //   if (i == localActiveIndex) {
      //     // console.log('Called fetch', i, localActiveIndex);
      //     // setSelectedPdfImageForCrop(imagesList[i].image);
      //     let croppedBuffer = new Blob([croppedImages[i].croppedFile]);
      //     uri = URL.createObjectURL(croppedBuffer);
      //   }
      // }
    } catch (error) {
      // console.error('Error fetching file:', error);
      // setError('Error fetching file');
    }
  };

const onUpdateEstimateName = async (fileName, newEstimateName) => {
    try {
      await updateEstimateName(fileName, newEstimateName);
    } catch (error) {
      console.error("Error updating estimate name:", error);
    }
  };

  //  const backClick = () => {
  //   setShowLightPlacementComp(false);
  //   if (isLightPlacement == true) {
  //     DisableGrid();
  //   } else if (startCropping == true) {
  //     setStartCropping(false);
  //     DisableGrid();
  //   } else {
  //     navigate("/");
  //     localStorage.setItem("showHomepage", "false");
  //   }
  // };

  const saveToStorage = (combos) => {
    localStorage.setItem("savedCombos", JSON.stringify(combos));
    setSavedCombos(combos);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setImage(base64);
        localStorage.setItem("uploadedImage", base64);
      };
      reader.readAsDataURL(file);
    }
  };

  const addCombo = (key) => {
    console.log("Adding combo with key:", key);
    if (!predefinedCombos[key]) return;
    const exists = savedCombos.find((c) => c.comboKey === key);
    if (exists) return;
    const newCombo = {
      comboKey: key,
      center: { x: 80, y: 80 },
      spacing: 10,
      anchor: { x: 5, y: 5 },
      stretch: { x: 5, y: 5 },
    };
    const updated = [...savedCombos, newCombo];
    saveToStorage(updated);
    setActiveKey(key);
  };

  const updateCombo = (key, updates) => {
    const updated = savedCombos.map((c) =>
      c.comboKey === key ? { ...c, ...updates } : c
    );
    saveToStorage(updated);
  };

  const removeCombo = (key) => {
    const updated = savedCombos.filter((c) => c.comboKey !== key);
    saveToStorage(updated);
    if (activeKey === key) setActiveKey("");
  };

  return (
  <div>
    <div className="page-content-custom-block">
      <div className="back-button">
        <button>
          {" "}
          <img src={backArraow} />
          Back
        </button>
      </div>
          <Header
            headerText={headerText}
            headerSaveText={headerSaveText}
            onUpdateEstimateName={onUpdateEstimateName}
            showEstimateName={true}
            showEditIcon={true}
          />
    </div>
      <div className="row">
        <div className="col-md-4">

        </div>
        <div className="col-md-6">

        
          <div className="canvas" ref={containerRef}>
            <TransformWrapper
              ref={zoomRef}
              minScale={0.5}
              maxScale={4}
              initialScale={1}
              doubleClick={{ disabled: true }}
              panning={{ disabled: isDraggingGroup }}
              centerOnInit={false}
              centerZoomedOut={false}
              limitToBounds={false}
              wheel={{ step: 0.01, smoothStep: 0.005, wheelEnabled: true }}
            >
              <TransformComponent
                wrapperStyle={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                contentStyle={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  transformOrigin: "top left",
                  transition: "transform 0.2s ease-out"
                }}
              >
                {image && (
                  <div className="image-wrapper" style={{ position: "relative" }}>
                    <img
                      ref={imageRef}
                      src={image}
                      alt="Uploaded"
                      className="floor-image"
                      draggable={false}
                      style={{ display: "block" }}
                    />
                    <div className="grid-overlay" />

                    {savedCombos.map((combo) => {
                      const offsets = predefinedCombos[combo.comboKey] || [];

                      const actionX = combo.center.x + combo.stretch.x + 50;
                      const actionY = combo.center.y + combo.stretch.y + 50;

                      return (
                        <React.Fragment key={combo.comboKey}>
                          {offsets.map((offset) => {
                            const offsetX = offset.fixedX
                              ? 0
                              : (30 + combo.stretch.x)*offset.col;
                            const offsetY = offset.fixedY
                              ? 0
                              : (30 + combo.stretch.y)*offset.row;
                            return (
                              <div
                                key={offset.id}
                                className="combo-dot"
                                style={{
                                  left: `${combo.center.x + offsetX}px`,
                                  top: `${combo.center.y + offsetY}px`,
                                }}
                              />
                            );
                          })}

                          <div
                            style={{
                              position: "absolute",
                              left: `${actionX}px`,
                              top: `${actionY}px`,
                              display: "flex",
                              gap: "6px",
                            }}
                          >
                            <div
                              className="drag-handle"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                const rect = imageRef.current.getBoundingClientRect();
                                const startOffsetX = e.clientX - rect.left - combo.center.x;
                                const startOffsetY = e.clientY - rect.top - combo.center.y;

                                setIsDraggingGroup(true);

                                const onMove = (ev) => {
                                  const newX = ev.clientX - rect.left - startOffsetX;
                                  const newY = ev.clientY - rect.top - startOffsetY;
                                  updateCombo(combo.comboKey, { center: { x: newX, y: newY } });
                                };

                                const onUp = () => {
                                  window.removeEventListener("mousemove", onMove);
                                  window.removeEventListener("mouseup", onUp);
                                  setIsDraggingGroup(false);
                                };

                                window.addEventListener("mousemove", onMove);
                                window.addEventListener("mouseup", onUp);
                              }}
                              title="Move Group"
                            >
                              ☰
                            </div>

                            <div
                              className="stretch-handle"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                const rect = imageRef.current.getBoundingClientRect();
                                const startOffsetX = e.clientX - rect.left - (combo.center.x + combo.stretch.x);
                                const startOffsetY = e.clientY - rect.top - (combo.center.y + combo.stretch.y);

                                setIsDraggingGroup(true);

                                const onMove = (ev) => {
                                  const mouseX = ev.clientX - rect.left - combo.center.x - startOffsetX;
                                  const mouseY = ev.clientY - rect.top - combo.center.y - startOffsetY;

                                  const newStretch = {
                                    x: Math.max(2, mouseX),
                                    y: Math.max(2, mouseY),
                                  };
                                  updateCombo(combo.comboKey, { stretch: newStretch });
                                };

                                const onUp = () => {
                                  window.removeEventListener("mousemove", onMove);
                                  window.removeEventListener("mouseup", onUp);
                                  setIsDraggingGroup(false);
                                };

                                window.addEventListener("mousemove", onMove);
                                window.addEventListener("mouseup", onUp);
                              }}
                              title="Stretch Combo"
                            >
                              ↔
                            </div>

                            <button
                              className="delete-button"
                              onClick={() => removeCombo(combo.comboKey)}
                              title="Delete Combo"
                            >
                              ✕
                            </button>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </TransformComponent>
            </TransformWrapper>
            {!hideHamburgerIcon && showHamburgerBlock === false && (
              <div
                className="hamburger-bar-icon"
                onClick={toggleHamburgerBlock}
              >
                <img src={hamburger} alt="Hamburger Icon" />
              </div>
            )}
            {hideHamburgerIcon === false &&
              showHamburgerBlock === true &&
              !startCropping && (
                <div className="hamburger-block crop-icon-block">
                  <div className="hamburger-inner crop-section-block">
                    {!showDeletePopup && !startCropping ? (
                      <>
                        <div className="popup-custom-icon-block">
                          <div className="delete-icon-block custom-block1">
                            {fileObj && (
                              <Popup
                                trigger={<DeleteIcon />}
                                position="right center"
                                className="delete-popup"
                              >
                                {(close) => (
                                  <div className="delete-popup-button-block">
                                    <div className="alert-icon-info">
                                      <div className="alert-icon">
                                        <img src={alertIcon}></img>
                                      </div>
                                      <h5>Delete Selected image!</h5>
                                    </div>
                                    <p>
                                      Are you sure you want to delete this
                                      image?
                                    </p>
                                    <div className="delete-btn-block">
                                      <button onClick={close}>Cancel</button>
                                      <button
                                        className="delete-block"
                                        onClick={() => {
                                          // handleDeleteFile(
                                          //   activePage,
                                          //   totalPages
                                          // );
                                          close();
                                        }}
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </Popup>
                            )}
                          </div>
                          <div className="delete-icon-block custom-block2">
                            <LightbulbIcon onClick={handleLightbulbClick} />
                          </div>

                          <div className="edit-icon-block custom-block3">
                            {/* <CropIcon */}
                            {/* <img
                        src={edit} */}
                            {/* <CropIcon
                              onClick={async () => {
                                setStartCropping(true);
                                setHeaderText("Crop Image");
                                setHeaderSaveText("Crop");
                                setIsGridBlockClicked(false);
                                if (
                                  pdfActualImages.length > 0 &&
                                  croppedFileName
                                ) {
                                  // setSelectedPdfImageForCrop(images[croppedFileName.split("page-")[1]?.split(".")[0]])
                                }
                                setMainImageToCrop();
                              }}
                              alt="Edit Icon"
                            /> */}
                          </div>
                          {/* <Popup
                          open={showLightPlacementPopup}
                          onClose={() => setShowLightPlacementPopup(false)}
                          className="light-placement-popup"
                        >
                          <div className="light-placement-popup-content">
                            <div className="alert-icon-info">
                              <div className="alert-icon">
                                <img src={alertIcon} alt="Alert Icon" />
                              </div>
                              <h5>Light Placement Alert!</h5>
                            </div>
                            <p>You have placed lights. You cannot crop the image now.</p>
                            <div className="popup-btn-block">
                              <button onClick={() => setShowLightPlacementPopup(false)}>OK</button>
                            </div>
                          </div>
                        </Popup> */}
                        </div>

                        <div className="hamburger-bar-icon close-icon-block">
                          {/* <img src={crossIcon} alt="Hamburger Icon" onClick={toggleHamburgerBlock} /> */}
                          <CloseIcon onClick={toggleHamburgerBlock} />
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              )}
          </div>
        </div>
        {isGridBlockClicked && (
                  // ((isGridBlockClicked == true) && (showLightPlacementComp == true))
                  // &&
                  <>
                    <div className="col-md-4 sidebar-open sidebar-block-area">
                      <Sidebar
                        contentClassName="contentClassName11"
                        overlayClassName="overlayClassName11"
                        rootClassName="rootClassName11"
                        sidebarClassName={`sidebarClassName11 sidebar-with-zoomIn`}
                        rootId="root-id11"
                        sidebarId="sidebarId11"
                        contentId="contentId11"
                        children="lights"
                        sidebar={
                          <div className="sidebar-block-content">
                            <button className="close-icon" onClick={closeSidebar}>
                              <img src={crossIcon} alt="Close Icon" />
                            </button>
                            {showLightPlacementComp && (
                              <>
                                <LightPlacementComponent
                                  categoryId={null}
                                  nodeId={null}
                                  selectedLight={null}
                                  onSendMessage={handleMessage}
                                  setShowLightPlacementComp={setShowLightPlacementComp}
                                />
                              </>
                            )}
                          </div>
                        }
                        open={showLightPlacementComp}
                        onSetOpen={handleLightPlacementToggle}
                        styles={{
                          sidebar: {
                            background: "white",
                            width: "650px",
                            zIndex: 99999999,
                            position: "fixed",
                            left: 0,
                          },
                          overlay: {
                            backgroundColor: "transparent",
                          },
                        }}
                        pullRight={false}
                      />
                      <div className="arrow-icon" onClick={handleLightPlacementToggle}>
                        <img src={crossIcon} alt="Arrow Icon" />
                      </div>
                    </div>
                  </>
                )}
      </div>
    
    </div>
  );
}